// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top-actions[data-v-f1f87b5e] {\n  padding: 30px;\n  background-color: #fff;\n}\n.top-actions .right-actions[data-v-f1f87b5e] {\n  width: 300px;\n  height: 40px;\n}\n.top-actions .left-actions[data-v-f1f87b5e] {\n  width: 350px;\n}\n.top-actions .right-actions .resource-groups-dropdown[data-v-f1f87b5e] {\n  width: 300px;\n}\n", ""]);
// Exports
module.exports = exports;
